import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { Button } from '@mui/material';
import { deleteCuttingReturn } from '../../../Store/PHPSlice/Cutting/cuttingApi';
import { DisabledByDefault } from '@mui/icons-material';

const TableBody = ({
    serialNumber,
    id,
    dt,
    ctMemo,
    empNm,
    itemId,
    itemNm,
    totIssqty,
    totReturnqty,
    cloth_return_sts,
    sts,
    sono,
    soId,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const handleClothReturn=()=>{
        window.open(`/CuttingReturnCloth/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    }
    const handleClothReturnInfo=()=>{
         window.open(`/CuttingReturnClothInfo/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    }

    const handleDeleteClick = () => {

        const isConfirmed = window.confirm("Are you sure you want to delete this Cutting Return?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteCuttingReturn(id))
                .then(() => {
                    // Reload the page to show updated results
                    // toast.success("Cloth Issue Deleted Sucessfully");
                    alert("Cloth Issue Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }
    };

    const handleViewClick = () => {
        window.open(`/CuttingMainReturn/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    const handleFinalPrint = () => {
        window.open(`/CuttingFinalPrint/${id}`, '_blank', 'width=1300,height=700,scrollbars=yes,resizable=yes');
    }

    return (
        <>
            <TableRow hover  role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {ctMemo}
                </TableCell>

                 <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sono}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {empNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {totIssqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {totReturnqty}
                </TableCell>
                 <TableCell
    sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }}
    align="center"
>
    {cloth_return_sts === '0' ? (
        <button
            className="btn btn-warning"
            onClick={handleClothReturn}
        >
            Return Cloth
        </button>
    ) : (
        <button
            className="btn btn-success" style={{background:'green'}}
            onClick={handleClothReturnInfo}
        >
            Returned
        </button>
    )}
</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <h4 onClick={handleFinalPrint} style={{ color: '#4d79ff', cursor: 'pointer' }}>Final Print</h4>
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts == '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>

            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
